// extracted by mini-css-extract-plugin
export default {"fullWidth":"qA-z","image":"rA-z","lazyLoadPicture":"sA-z","lazyLoadSpinner":"tA-z","lazyLoadSpin":"uA-z","lazyLoadImage":"vA-z","hasStyledAspectRatio":"wA-z"};